export default {
    tab: 'Growth charts',
    subtitle: "Your customer's measurements compared with children of the same sex and age",
    charts: {
        'weight-length-0-2': {
            title: 'Weight and length for age',
            short: 'Weight and length 0–2',
            ages: '0–2 years',
        },
        'weight-for-length-0-2': {
            title: 'Weight for length',
            short: 'Weight for length 0–2',
            ages: '0–2 years',
        },
        'weight-length-height-0-5': {
            title: 'Weight and length/height for age',
            short: 'Weight and length/height 0–5',
            ages: '0–5 years',
        },
        'head-circumference-0-5': {
            title: 'Head circumference for age',
            short: 'Head circumference 0–5',
            ages: '0–5 years',
        },
        'weight-height-5-18': {
            title: 'Weight and height for age',
            short: 'Weight and height 5–18',
            ages: '5–18 years',
        },
        'bmi-2-18': {
            title: 'Body mass index for age',
            short: 'BMI 2–18',
            ages: '2–18 years',
        },
    },
    pastCharts: 'Earlier charts',
    sexes: {
        F: 'Girls',
        M: 'Boys',
    },
    sources: {
        who2006: 'Source: World Health Organization (WHO Child Growth Standards)',
        who2007: 'Source: World Health Organization (2007 WHO Reference)',
        iotf2012: 'Source: International Obesity Task Force (Revised BMI cut-offs, 2012)',
    },
    measures: {
        length: 'Length/height',
        height: 'Height',
        weight: 'Weight',
        head: 'Head circumference',
        bmi: 'BMI',
    },
    axis: {
        ageYears: 'Age (years)',
        ageMonths: 'Age (years / months)',
        length: 'Length (cm)',
    },
    birth: 'Birth',
    years: '{count} year | {count} years',
    age: {
        years: '{count} year | {count} years',
        months: '{count} month | {count} months',
    },
    centile: '{centile} percentile',
    centileWord: 'percentile',
    // by Intl.PluralRules' ordinal category
    ordinal: {
        one: '{n}st',
        two: '{n}nd',
        few: '{n}rd',
        other: '{n}th',
    },
    zScore: 'z {value}',
    adultBmi: 'Adult-equivalent BMI (IOTF): {value}',
    heightFrom: 'Height from {date}',
    notes: {
        lengthHeight: {
            line1: 'Until 2 years, record length (lying down).',
            line2: 'From 2 years, record height (standing).',
        },
        weightAfterTen: {
            line1: 'From puberty, weight-for-age',
            line2: 'is not a reliable measure',
            line3: 'of under- or overweight.',
            line4: 'After 10 years, use the BMI chart.',
        },
        iotf: {
            title: 'Lines match an adult BMI of 30, 25, 18.5, 17 and 16 at 18',
            obesity: 'On line 30 or above: obesity',
            overweight: 'On line 25 or above (up to 30): overweight',
            thinness1: 'Below 18.5 (down to 17): mild thinness',
            thinness2: 'Below 17 (down to 16): moderate thinness',
            thinness3: 'Below 16: severe thinness',
            severeObesity: 'At or above the BMI 35 equivalent: severe obesity',
        },
    },
    categories: {
        severeObesity: 'Severe obesity',
        obesity: 'Obesity',
        overweight: 'Overweight',
        normal: 'Normal weight',
        thinness1: 'Mild thinness',
        thinness2: 'Moderate thinness',
        thinness3: 'Severe thinness',
    },
    zoom: {
        full: 'Whole chart',
        focus: 'Focus on measurements',
        label: 'Chart range',
    },
    cards: {
        bmi: 'BMI (IOTF)',
        bmiDetail: '{bmi} kg/m² · {weight} kg, {height} cm',
        bmiNeedsHeight: 'Add a new height for an up-to-date BMI',
        length: 'Length',
        weightForLength: 'Weight for length',
        weightForLengthDetail: '{weight} kg at {length} cm long',
    },
    trend: {
        from: 'from {value} ({date})',
        stable: 'steady',
        channelChange: 'channel change',
        sd: '{value} SD',
    },
    table: {
        title: 'Measurements',
        date: 'Date',
        age: 'Age',
        showAll: 'All measurements ({count})',
        showLess: 'Show fewer',
        heightFrom: 'from {date}',
    },
    missing: {
        title: 'Customer details missing',
        text: 'To see growth charts, add the customer’s {fields} to their profile.',
        sex: 'sex',
        birthDate: 'date of birth',
        and: 'and',
    },
    failed: {
        title: "Couldn't load the growth charts",
        text: 'Something went wrong. Try again in a moment.',
        retry: 'Try again',
    },
    implausible: {
        short: 'check this measurement',
        tooltip: 'Outside WHO plausibility limits: check this measurement',
    },
    preterm: 'Chronological age, not corrected for prematurity',
    noPoints: 'Add height and weight in body measurements to mark them on the chart.',
    noCharts: 'Growth charts are for customers up to 18 years old.',
    noChartsTitle: 'No charts for this age',
    print: {
        customer: 'Customer',
        birthDate: 'Date of birth',
        centileNote: 'Percentile: at the 85th, 85 in 100 children of the same sex and age have a lower value.',
        screeningNote: 'Growth charts are a monitoring tool, not a diagnosis.',
    },
};
